import MarkdownFastProgressiveRender from "../markdownFastRender.js";
import MessageOptionBar from "../messageOptionBar.js";
import React, { useState, useEffect, useRef, createRef } from 'react';
import History from "./history.js";

function MessageList({chatBoxRef, messages,  introductionMessageLength, dynamicActions, setAutoScroll}){
    const contentRef = useRef();
    //const [autoScroll, setAutoScroll] = useState(true);
    const [expandedReflections, setExpandedReflections] = useState({}); // état par message key
    // état pour forcer un rafraîchissement régulier (timer)
    const [now, setNow] = useState(Date.now());
    useEffect(() => {
        // démarrer le timer seulement si au moins un message a startTime et message vide (ou falsy)

        let id = setInterval(() => setNow(Date.now()), 1000);
        return () => {
            if (id) clearInterval(id);
        };
    }, [now]);

    const toggleReflection = (key) => {
        setExpandedReflections(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    function stopAutoScroll(e) {
        if(setAutoScroll == undefined){
            return;
        }
        const wheelDirection = e.deltaY < 0 ? 'up' : 'down';
        if (wheelDirection == 'up') {
          setAutoScroll(false);
        } else if (wheelDirection == 'down') {
          const chat = chatBoxRef.current;
          const isScrolledToBottom = chat.scrollHeight - chat.scrollTop - chat.clientHeight <= chat.clientHeight + 1;
          if (isScrolledToBottom) {
            setAutoScroll(true);
          }
        }
    }

    function formatElapsed(startMs, nowMs) {
        const total = Math.max(0, Math.floor((nowMs - startMs) / 1000));
        const h = Math.floor(total / 3600);
        const m = Math.floor((total % 3600) / 60);
        const s = total % 60;
        if (h > 0) return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
        return `${m}:${String(s).padStart(2, '0')}`;
    }

    return (
        <>
            {Object.keys(messages).length > 0 && (
                <div ref={chatBoxRef} className={`relative overflow-y-auto ${Object.keys(messages).length > 1 ? 'h-[50vh] min-h-[20em]' : ''}`} onWheel={stopAutoScroll}>

                    {Object.entries(messages).map(([key, message]) => {
                    return (
                    <div key={key} className={`mr-4 mt-4 p-4 rounded-lg text-base sm:text-lg lg:text-xl text-gray-900 ${message.type === 'ia' ? 'bg-indigo-300' : 'bg-gray-100'}`}>
                        
                        {/* Bouton indépendant par message */}
                        {message.outputList && message.outputList.length > 0 && (
                            <button 
                                onClick={() => toggleReflection(key)}
                                className="mb-2 px-3 py-1 bg-indigo-500 text-white rounded hover:bg-indigo-600"
                            >
                                {expandedReflections[key] ? 'Masquer la réflexion' : 'Afficher la réflexion >'}
                            </button>
                        )}

                        {/* Affichage conditionnel de outputList */}
                        {expandedReflections[key] && message.outputList && message.outputList.length > 0 && (
                            <div className="mb-3 space-y-2 pl-4 border-l-2 border-white/30">
                                {message.outputList.map((output, idx) => (
                                    <React.Fragment key={idx}>
                                        <div className="p-2 bg-white/50 rounded">
                                            {output.type === 'text' && (
                                                <MarkdownFastProgressiveRender message={output.content} />
                                            )}
                                            {output.type === 'code' && (
                                                <MarkdownFastProgressiveRender message={output.content} />
                                            )}
                                        </div>
                                        {idx < message.outputList.length - 1 && (
                                            <hr className="border-gray-300" />
                                        )}
                                    </React.Fragment>
                                ))}
                            </div>
                        )}

                        <div ref={contentRef}>
                            {/* Si startTime existe et message vide, afficher timer rafraîchi */}
                            {(message.startTime && message.message == "") && (
                                <div className="text-sm text-gray-600 mb-2">
                                    Kojyto AI réfléchit depuis : {formatElapsed(Number(message.startTime), now)}
                                </div>
                            )}

                            <MarkdownFastProgressiveRender message={`<div>${message.message}</div>`} />
                        </div>
                        {Object.keys(messages).length > introductionMessageLength && (
                            <MessageOptionBar 
                                htmlContent={message.message}
                                dynamicActions={dynamicActions}
                                contentRef={contentRef}
                            />
                        )}
                    </div>
                    );
                    })}
                </div>
            )}
        </>
    )
}

export default MessageList;